import {useEffect, useState} from "react";
import {useKeycloak} from "@react-keycloak/web";
import {ApiKeysClient, Organization} from "../clients/ApiKeysClient";

let orgs: Organization[] = []

export default function useOrganizations() {
    const [organizations, setOrganizations] = useState<Organization[]>([])
    const token = useKeycloak().keycloak.token

    useEffect(() => {
        if(orgs.length > 0) {
          // Organizations already have been loaded and will be reused
          setOrganizations(orgs)
          return
        }

        if (token === undefined) {
            console.error("failed to get organizations: no token")
            setOrganizations([])
            return
        }

        const client = new ApiKeysClient(token);

        client.fetchOrganizations()
            .then(fetchedOrganizations => {
                orgs = fetchedOrganizations
                setOrganizations(fetchedOrganizations);
            }).catch(err => {
                console.error("failed to fetch organizations", err);
            })
    // disabled warning because it will fail build, but adding token as dependency will cause unwanted
    // organization fetches after a token has been refreshed
    // eslint-disable-next-line
    }, [])

    return organizations
}


